module.exports = __webpack_public_path__ + "static/media/loading.c5590569.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Callback/loading.svg
// module id = 2249
// module chunks = 0